import edeka from "shared/i18n-messages/edeka.de";
import fs from "shared/i18n-messages/fs.de";
import interaction from "shared/i18n-messages/interaction.de";

import dashboard from "./i18n-messages/dashboard.de";

import orderUnit from "./i18n-messages/models/orderUnit.de";

import welcome from "../welcome/i18n-messages/welcome.de";

export default {
  locale: "de",
  messages: {
    ...edeka,
    ...fs,
    ...interaction,

    ...dashboard,

    ...orderUnit,

    ...welcome,
  },
};
